// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

function Component(T) {
  var desktopStyling = [
    BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(16)),
    BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(16)),
    BsCssJs$PrezzeeRibbon.display("inlineBlock"),
    BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(32)),
    BsCssJs$PrezzeeRibbon.lastChild([BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(32))]),
    BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, [
          BsCssJs$PrezzeeRibbon.display("flex"),
          BsCssJs$PrezzeeRibbon.alignItems("stretch"),
          BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
          BsCssJs$PrezzeeRibbon.borderBottomStyle(BsCssJs$PrezzeeRibbon.solid),
          BsCssJs$PrezzeeRibbon.borderBottomWidth(BsCssJs$PrezzeeRibbon.px(3)),
          BsCssJs$PrezzeeRibbon.borderColor("transparent"),
          BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
          BsCssJs$PrezzeeRibbon.hover([BsCssJs$PrezzeeRibbon.borderBottomColor(T.hoverColour)])
        ])
  ];
  var mobileStyling = [
    BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(22)),
    BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(30)),
    BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(12)),
    BsCssJs$PrezzeeRibbon.fontWeight("normal")
  ];
  var navigationItem = BsCssJs$PrezzeeRibbon.merge([
        Theme__Typography$PrezzeeRibbon.Styles.style5,
        BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.regular),
              BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
              BsCssJs$PrezzeeRibbon.transitionProperty("border-color"),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, desktopStyling),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, mobileStyling),
              BsCssJs$PrezzeeRibbon.selector("a", [
                    BsCssJs$PrezzeeRibbon.color(T.linkColour),
                    BsCssJs$PrezzeeRibbon.textDecoration(BsCssJs$PrezzeeRibbon.none),
                    BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.regular),
                    BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
                    BsCssJs$PrezzeeRibbon.transitionProperty("color"),
                    BsCssJs$PrezzeeRibbon.hover([BsCssJs$PrezzeeRibbon.color(T.hoverColour)]),
                    BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
                          BsCssJs$PrezzeeRibbon.display("flex"),
                          BsCssJs$PrezzeeRibbon.alignItems("center")
                        ])
                  ])
            ])
      ]);
  var Styles = {
    desktopStyling: desktopStyling,
    mobileStyling: mobileStyling,
    navigationItem: navigationItem
  };
  var Navigation__Item$Component = function (props) {
    return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
                children: JsxRuntime.jsx("li", {
                      children: props.children,
                      className: navigationItem
                    })
              });
  };
  return {
          Styles: Styles,
          make: Navigation__Item$Component
        };
}

export {
  Component ,
}
/* react/jsx-runtime Not a pure module */
